import { render, staticRenderFns } from "./trainerFeedback.vue?vue&type=template&id=27ce1e12"
import script from "./trainerFeedback.vue?vue&type=script&lang=js"
export * from "./trainerFeedback.vue?vue&type=script&lang=js"
import style0 from "./trainerFeedback.vue?vue&type=style&index=0&id=27ce1e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports